import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useOutletContext, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import Select from "react-select";
import toastr from "../../../utils/toast";

function EditContract({ id, onClose }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    unregister,
    clearErrors,
    formState: { errors },
  } = useForm();
  const [data, setData] = useState([]);
  const [ref, setref] = useState([]);
  const [retsplit, setretsplit] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [clienttypes, setClienttypes] = useState([]);
  const [entities, setEntities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [noPoachClause, setnoPoachClause] = useState(null);
  const [currency, setCurrencies] = useState([]);
  const [retainertype, setRetainerTypes] = useState([]);
  const [selectretainertype, setselectretainertype] = useState(null);
  const [clienttype, setClientType] = useState(null);
  const [count, setCount] = useState(3);
  const [feetype, setFeeType] = useState("RoleWise");
  const [roleNumber, setroleNumber] = useState("single-condition");
  const [feecaptype, setFeeCapType] = useState(null);
  const [terminationClause, setTerminationClause] = useState(null);
  const [nopoach, setNoPoach] = useState(null);
  const [extraInputs, setExtraInputs] = useState([]);
  const [SelectedCountry, setSelectedCountry] = useState([]);
  const [SelectedRegion, setSelectedRegion] = useState([]);
  const [disableExpense, setDisableExpense] = useState(false);
  const splitNum = watch("split_num");
  const clientRetainerTypeId = watch("clientretainertype_id");
  const [compensationComponents, setCompensationComponents] = useState([]);
  const [selectedCompensationComponents, setSelectedCompensationComponents] = useState([1, 2]);
  const [dropdownsLoaded, setDropdownsLoaded] = useState(false);
  const handleAddMore = (e) => {
    e.preventDefault();
    setExtraInputs((prev) => [...prev, prev.length + 3]);
  };

  const handleCompensationComponentChange = (componentId, checked) => {
    setSelectedCompensationComponents((prev) => {
      if (checked) {
        return [...new Set([...prev, componentId])];
      }

      return prev.filter((id) => id !== componentId);
    });
  };

  const peVcReferredOption = watch("peVcReferredOption");

  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/contracts/get_contract_details/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Data is coming", response.data);

        const retainers = response.data.ref_list.find(
            x => x.key === "retainersplits"
        )?.data || [];

        setCount(retainers.length);
        setValue("split_num", String(retainers.length));
        setref(response.data.ref_list[0].data || []);
        let my_index = 1;
        for (const [index, item] of Object.entries(
          response.data.ref_list[1].data
        )) {
          console.log(my_index);
          setValue(`p_scnt_${my_index}`, item.name);
          setValue(`p_scnt_note_${my_index}`, item.note);
          my_index++;
        }
        let my_index2 = 0;
        for (const [index, item] of Object.entries(
          response.data.ref_list[2].data
        )) {
          console.log(my_index2);
          setValue(`p_level_name.${my_index2}`, item.name);
          setValue(`p_level_rangefrom.${my_index2}`, item.rangeFrom);
          setValue(`p_level_rangeto.${my_index2}`, item.rangeTo);
          setValue(`p_level_amount.${my_index2}`, item.amount);
          setValue(`p_levelcap_name.${my_index2}`, item.name);
          setValue(`p_levelcap_amount.${my_index2}`, item.capAmount);
          my_index2++;
        }
        
        const contractComponents =
          response.data.ref_list.find(
            (x) => x.key === "compensation_components"
          )?.data || [];

        // Normalize + remove duplicate component IDs
        const normalizedComponents = contractComponents
          .map((component) => ({
            ...component,
            id: Number(component.component_id),
            applicable: Number(component.applicable),
            is_required: Number(component.is_required),
          }))
          .filter(
            (component, index, self) =>
              index === self.findIndex((c) => c.id === component.id)
          );

        setCompensationComponents(normalizedComponents);

        // Select components which are applicable
        if (normalizedComponents.length > 0) {
          const selectedIds = normalizedComponents
            .filter((component) => component.applicable === 1)
            .map((component) => component.id);

          setSelectedCompensationComponents([...new Set(selectedIds)]);
        } else {
          // Default components
          setSelectedCompensationComponents([1, 2]);
        }

      } catch (error) {
        console.error("API Error:", error);
        setGlobalLoading(false);
      }
    }
    fetchOptions();
  }, [id]);

  useEffect(() => {
    if (!ref || !dropdownsLoaded) return;

    console.log("Contract Ref:", ref);
    for (const [key, value] of Object.entries(ref)) {
        setValue(key, value ?? "");
    }
    
    // Explicitly set dropdown values
    const clientTypeId = Number(ref.clienttype_id);
    const retainerTypeId = String(ref.clientretainertype_id ?? "");
    const entityId = String(ref.entity_id ?? "");

    setValue("clienttype_id", String(clientTypeId));
    setValue("clientretainertype_id", retainerTypeId);
    setValue("entity_id", entityId);
    // Update dependent states
    setClientType(clientTypeId);
    setselectretainertype(retainerTypeId);
    setFeeType(ref.fee_type || "");

    setGlobalLoading(false);
    const arr = (ref.fee ?? "").split(",").map((item) => item.trim());
    const feesvalue = arr.reduce(
      (acc, val) => ({ ...acc, [val]: (acc[val] || 0) + 1 }),
      {}
    );

    // ---------------------- NEW LOGIC ----------------------
    // Get fees in the order they appear
    const feesInOrder = [];
    const seen = new Set();

    for (const fee of arr) {
      if (!seen.has(fee)) {
        feesInOrder.push(fee);
        seen.add(fee);
      }
    }

    // Get counts for each fee
    const countsInOrder = feesInOrder.map((fee) => feesvalue[fee]);

    // Number of distinct conditions
    const conditionNumber = feesInOrder.length;

    if (conditionNumber === 1) {
      setroleNumber("single-condition");
      setValue(`role_number`, "single-condition");
      setValue(`type_one_fee`, feesInOrder[0]);
      setValue(`type_one_number`, countsInOrder[0]); // optional, if you track numbers
    } else if (conditionNumber === 2) {
      setroleNumber("two-condition");
      setValue(`role_number`, "two-condition");
      setValue(`type_one_fee`, feesInOrder[0]);
      setValue(`type_one_number`, countsInOrder[0]);
      setValue(`type_two_fee`, feesInOrder[1]);
      setValue(`type_two_number`, countsInOrder[1]);
    } else if (conditionNumber === 3) {
      setroleNumber("three-condition");
      setValue(`role_number`, "three-condition");
      setValue(`type_one_fee`, feesInOrder[0]);
      setValue(`type_one_number`, countsInOrder[0]);
      setValue(`type_two_fee`, feesInOrder[1]);
      setValue(`type_two_number`, countsInOrder[1]);
      setValue(`type_three_fee`, feesInOrder[2]);
      setValue(`type_three_number`, countsInOrder[2]);
    }

    nopoachChange(ref.noPoachClause);
    if (ref.noPoachClause == "country") {
      setValue(`country_id`, ref.noPoachClauseValue);
      setValue(`noPoachEndDateCountry`, ref.noPoachEndDate);
      setSelectedCountry(ref.noPoachClauseValue);
    } else if (ref.noPoachClause == "region") {
      setValue(`region_id`, ref.noPoachClauseValue);
      setValue(`noPoachEndDateRegion`, ref.noPoachEndDate);
      setSelectedRegion(ref.noPoachClauseValue);
    }
    setTerminationClause(ref.terminationClause);
    setValue("fee_cap_type", ref.fee_cap_type);
    setFeeCapType(ref.fee_cap_type);
  }, [ref, dropdownsLoaded, setValue]);

  // Fetch dropdown data once on mount
  useEffect(() => {
    async function fetchAllDropdownData() {
      setGlobalLoading(false); //  Show loader before API call
      try {
        const res = await axios.get(`${API_BASE_URL}/contracts/contractd`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = res.data;
        setData(data);
        setCompanies(data.companies || []);
        setClienttypes(data.clienttypes || []);
        setEntities(data.entities || []);
        setCountries(data.countries || []);
        setRegions(data.regions || []);
        setCurrencies(data.currencies || []);
        setRetainerTypes(data.retainertypes || []);
        setDropdownsLoaded(true);
        setValue("currency_id", data.currencies[0].id);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchAllDropdownData();
  }, []);

  useEffect(() => {
    register("company_id", {
      required: "Please select a company",
    });
  }, [register]);

  const onSubmit = async (data) => {
    if (noPoachClause === "region") {
      if (!SelectedRegion || SelectedRegion.length === 0) {
        // Show error, focus the select2, and stop
        const $selectCountry = $("select[name='region_id']");
        // Focus on the select2 dropdown
        $selectCountry.select2("open");

        return; // Prevent further processing
      }
    } else if (noPoachClause === "country") {
      if (!SelectedCountry || SelectedCountry.length === 0) {
        // Show error, focus the select2, and stop
        const $selectCountry = $("select[name='country_id']");
        // Focus on the select2 dropdown
        $selectCountry.select2("open");

        return; // Prevent further processing
      }
    }

    const formData = new FormData();

    // loop through all keys in data
    Object.keys(data).forEach((key) => {
      const value = data[key];

      if (value instanceof FileList) {
        // if it's a file input (FileList), add first file
        if (value.length > 0) {
          formData.append(key, value[0]);
        }
      } else {
        // otherwise add as a normal field
        formData.append(key, value);
      }
    });

    formData.append(
      "compensation_component_ids",
      JSON.stringify(selectedCompensationComponents)
    );

    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/contracts/edit_contract`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response);
      toastr.success("Contract update successfully!");
      onClose();
      setTimeout(() => {
        navigate("/contract/list");
      }, 1000);

      // setShowModal(false);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating contract.");
    } finally {
      setGlobalLoading(false);
    }
  };

  // ############################################################
  const splitSelectChange = (e) => {
    setCount(Number(e.target.value)); // convert string to number
  };

  const retainerTypeSelectChange = (e) => {
    setselectretainertype(e.target.value);
  };
  const feeSelectChange = (e) => {
    setFeeType(e.target.value);
  };
  const clienttypeSelectChange = (e) => {
    setClientType(parseInt(e));
  };
  const feeCapSelectChange = (e) => {
    setFeeCapType(e.target.value);
  };

  const roleNumberChange = (e) => {
    setroleNumber(e.target.value);
  };

  const terminationClauseChange = (e) => {
    setTerminationClause(e.target.value);
  };

  const nopoachChange = (e) => {
    console.log(e);
    setNoPoach(e);
    setnoPoachClause(e);
  };

  useEffect(() => {
    console.log(noPoachClause);
    if (noPoachClause === "region") {
      const $select = $("[name='region_id']");
      $select.select2({
        placeholder: "Please Select Regions",
        width: "100%",
      });

      $select.on("change", function () {
        const selectedValue = $(this).val();
        setValue("region_id", selectedValue);
        setSelectedRegion(selectedValue);
      });

      return () => {
        $select.off("change").select2("destroy");
      };
    } else if (noPoachClause === "country") {
      const $select = $("[name='country_id']");
      $select.select2({
        placeholder: "Please Select Countries",
        width: "100%",
      });

      $select.on("change", function () {
        const selectedValue = $(this).val();
        setValue("country_id", selectedValue);
        setSelectedCountry(selectedValue);
      });

      return () => {
        $select.off("change").select2("destroy");
      };
    }
  }, [noPoachClause]);

  const contractStart = watch("contractstart");
  useEffect(() => {
    if (contractStart) {
      const startDate = new Date(contractStart);
      const endDate = new Date(startDate);
      endDate.setFullYear(endDate.getFullYear() + 1); // add 1 year
      endDate.setDate(endDate.getDate() - 1);

      // Format date as yyyy-mm-dd for input[type=date]
      const formattedEnd = endDate.toISOString().split("T")[0];

      // Set the contractend field value
      setValue("contractend", formattedEnd);
    }
  }, [contractStart, setValue]);

  const getSplitValues = () => {
    return [...Array(Number(splitNum || count))].map((_, i) => {
      const raw = watch(`p_scnt_${i + 1}`) || "";
      const numericValue = parseFloat(raw.toString().replace("%", ""));
      return isNaN(numericValue) ? 0 : numericValue;
    });
  };

  const companyOptions = companies.map((company) => ({
    value: String(company.id),
    label: company.name,
  }));

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered modal-md add_contract_modal"
        role="document"
        style={{ maxWidth: "950px" }}
      >
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">
                Edit Contract
                <span style={{ marginLeft: "20px" }}>
                  <button type="button" className="btn btn-primary my-1 me-2">
                    AGN No.{" "}
                    <span className="badge ms-2 bg-secondary">{ref.agn}</span>
                  </button>
                </span>
              </h4>
              <button
                onClick={() => onClose()}
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract Name *</label>
                    <input type="hidden" {...register("id")} value={data.id} />
                    <input
                      type="text"
                      {...register("contract_name", { required: "required" })}
                      className={`form-control ${
                        errors.contract_name && "is-invalid"
                      }`}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Client Name *</label>
                    <Select
                      options={companyOptions}
                      value={
                        companyOptions.find(
                          (option) => option.value === String(watch("company_id"))
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setValue("company_id", selectedOption?.value || "", {
                          shouldValidate: true,
                          shouldDirty: true,
                        })
                      }
                      placeholder="Select Company"
                      isSearchable
                    />

                    {errors.company_id && (
                      <div className="text-danger mt-1">
                        {errors.company_id.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Client Type *</label>
                    <select
                      {...register("clienttype_id", {
                        required: "Please select client type",
                      })}
                      onChange={(e) => {
                            const value = e.target.value;
                            setValue("clienttype_id", value, {shouldValidate: true, shouldDirty: true,});
                            setClientType(Number(value));
                        }}
                      className={`form-select ${errors.clienttype_id && "is-invalid"}`}
                    >
                      <option value="">Select</option>
                      {clienttypes.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {clienttype === 3 ? (
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label className="form-label">Retainer Type *</label>
                      <select
                        {...register("clientretainertype_id", {
                          required: "Please select retainer type",
                        })}
                        onChange={(e) => {
                            const value = e.target.value;
                            setValue("clientretainertype_id", value, {shouldValidate: true, shouldDirty: true});
                            setselectretainertype(value);
                        }}
                        className={`form-select ${errors.clientretainertype_id && "is-invalid"}`}
                      >
                        <option value="">Select</option>
                        {retainertype.map((m) => (
                          <option key={m.id} value={m.id}>
                            {m.type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-4 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Entity *</label>
                    <select
                      {...register("entity_id", {
                        required: "Please select entity",
                      })}
                      className={`form-select ${
                        errors.entity_id && "is-invalid"
                      }`}
                    >
                      <option value="">Select</option>
                      {entities.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row border-bottom mb-3">
                <div className="col-md-3 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract Signed</label>
                    <select
                      {...register("contractSigned")}
                      className="form-select"
                    >
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract Date</label>
                    <div className="input-icon position-relative w-100 me-2">
                      <input
                        type="date"
                        {...register("contractdate", { required: "required" })}
                        className={`datetimepicker form-control ${
                          errors.contractdate && "is-invalid"
                        }`}
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract Start</label>
                    <div className="input-icon position-relative w-100 me-2">
                      <input
                        type="date"
                        {...register("contractstart", { required: "required" })}
                        className={`datetimepicker form-control ${
                          errors.contractstart && "is-invalid"
                        }`}
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract End</label>
                    <div className="input-icon position-relative w-100 me-2">
                      <input
                        type="date"
                        {...register("contractend", {
                          required: "required",
                          validate: (value) => {
                            const start = watch("contractstart");
                            if (!start || !value) return true;

                            const startDate = new Date(start);
                            const minEndDate = new Date(startDate);
                            minEndDate.setMonth(minEndDate.getMonth() + 3);
                            const endDate = new Date(value);
                            return (
                              endDate >= minEndDate ||
                              "Contract end must be at least 3 months after contract start"
                            );
                          },
                        })}
                        className={`datetimepicker form-control ${
                          errors.contractend && "is-invalid"
                        }`}
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {clienttype === 3 && selectretainertype != 3 ? (
                <div className="row">
                  <div className="border-bottom mb-3">
                    <h4 className="mb-2">Retainer Breakup</h4>
                    <div className="border rounded p-3 mb-3">
                      <div className="">
                        <div className="row col-md-12">
                          <div className="col-md-3 p-3">
                            <label className="form-label">
                              Number Of Split
                            </label>
                            <select
                              {...register("split_num")}
                              onChange={splitSelectChange}
                              className="form-select"
                            >
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                              <option value="4">Four</option>
                            </select>
                          </div>
                          <div className="border rounded p-3 mb-3 col-md-9 row">
                            <div className="col-md-3">
                              <div className="mb-3">
                                <label className="form-label">
                                  Retainer Split *
                                </label>
                                {[...Array(count)].map((_, i) => (
                                  <div style={{ marginTop: "5px" }}>
                                    <input
                                      type="text"
                                      {...register(`p_scnt_${i + 1}`, {
                                        required: "required",
                                        validate: {
                                          percentageOrFixed: () => {
                                            if (
                                              Number(clientRetainerTypeId) !== 1
                                            ) {
                                              return true;
                                            }
                                            const values = getSplitValues();
                                            const hasPercentage = values.some(
                                              (v) => v > 0 && v < 100,
                                            );
                                            if (hasPercentage) {
                                              const sum = values.reduce(
                                                (a, b) => a + b,
                                                0,
                                              );
                                              if (sum !== 100) {
                                                return "Percentage splits must total 100";
                                              }
                                            }
                                            return true;
                                          },
                                        },
                                        pattern: {
                                          value:
                                            /^(?!\.)(?!.*\.\.)(\d+(\.\d+)?%?)?$/,
                                          message:
                                            "Only numbers, decimal, and % are allowed",
                                        },
                                      })}
                                      key={i}
                                      placeholder={`split ${i + 1}`}
                                      className={`form-control ${
                                        errors[`p_scnt_${i + 1}`] &&
                                        "is-invalid"
                                      }`}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div className="col-md-9">
                              <div className="row">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Give details on when is the Retainer to be
                                    charged *
                                  </label>
                                  {[...Array(count)].map((_, i) => (
                                    <div style={{ marginTop: "5px" }}>
                                      <input
                                        type="text"
                                        {...register(`p_scnt_note_${i + 1}`, {
                                          required: "required",
                                        })}
                                        key={i}
                                        placeholder={`split notes ${i + 1}`}
                                        className={`form-control ${
                                          errors[`p_scnt_note_${i + 1}`] &&
                                          "is-invalid"
                                        }`}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="row">
                <div className="border-bottom mb-3">
                  <h4 className="mb-2">Fees Details</h4>
                  <div className="border rounded p-3 mb-3">
                    <div className="">
                      <div className="row col-md-12">
                        <div className="col-md-3 p-3">
                          <label className="form-label">Fee Type</label>
                          <select
                            {...register("fee_type")}
                            onChange={feeSelectChange}
                            className="form-select"
                          >
                            <option selected value="RoleWise">
                              RoleWise
                            </option>
                            <option value="LevelWise">LevelWise</option>
                          </select>
                        </div>
                        {feetype === "RoleWise" ? (
                          <div className="border rounded p-3 mb-3 col-md-9 row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label d-block text-wrap">
                                  Pricing Conditions → Fee tiers based on number
                                  of roles (e.g., 2 roles at 20%, 3 roles at
                                  25%, remaining at 30% = 3 conditions). *
                                </label>
                                <select
                                  {...register("role_number")}
                                  onChange={roleNumberChange}
                                  className="form-select"
                                >
                                  <option value="single-condition">One</option>
                                  <option value="two-condition">Two</option>
                                  <option value="three-condition">Three</option>
                                </select>
                              </div>
                            </div>
                            {roleNumber === "single-condition" ? (
                              <div className="col-md-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Fee Percentage (flat or %)
                                  </label>
                                  <input
                                    {...register(`type_one_fee`, {
                                      required: "required",
                                    })}
                                    key="type_one_fee"
                                    type="text"
                                    placeholder={`i.e. 25% or 2000000 (Flat Fee)`}
                                    className={`form-control ${
                                      errors.type_one_fee && "is-invalid"
                                    }`}
                                  />
                                </div>
                              </div>
                            ) : (
                              <>
                                {roleNumber === "two-condition" ? (
                                  <>
                                    <div className="col-md-12 row">
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label className="form-label">
                                            No of Roles
                                          </label>
                                          <input
                                            {...register(`type_one_number`, {
                                              required: "required",
                                            })}
                                            key="type_one_number"
                                            type="number"
                                            min={1}
                                            className={`form-control ${
                                              errors.type_one_number &&
                                              "is-invalid"
                                            }`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label className="form-label">
                                            Fee (flat fee or %)
                                          </label>
                                          <input
                                            {...register("type_one_fee", {
                                              required: "required",
                                            })}
                                            type="text"
                                            placeholder="eg. 25% or 2000000 (Flat Fee)"
                                            className={`form-control ${
                                              errors.type_one_fee &&
                                              "is-invalid"
                                            }`}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-12 row">
                                      <div className="col-md-6">
                                        <div
                                          className="mb-3 border border-dark text-center"
                                          style={{
                                            borderColor:
                                              "rgba(221, 231, 241, 0.4)",
                                          }}
                                        >
                                          <label className="form-label p-0 mt-2 mb-1">
                                            Remaining Roles
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <input
                                            {...register(`type_two_fee`, {
                                              required: "required",
                                            })}
                                            key="type_two_fee"
                                            type="text"
                                            placeholder="eg. 25% or 2000000 (Flat Fee)"
                                            className={`form-control ${
                                              errors.type_two_fee &&
                                              "is-invalid"
                                            }`}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="col-md-12 row">
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label className="form-label">
                                            No of Roles
                                          </label>
                                          <input
                                            {...register(`type_one_number`, {
                                              required: "required",
                                            })}
                                            key="type_one_number"
                                            type="number"
                                            min={1}
                                            className={`form-control ${
                                              errors.type_one_number &&
                                              "is-invalid"
                                            }`}
                                          />
                                          <input
                                            {...register(`type_two_number`, {
                                              required: "required",
                                            })}
                                            key="type_two_number"
                                            type="number"
                                            min={1}
                                            className={`form-control ${
                                              errors.type_two_number &&
                                              "is-invalid"
                                            } mt-1`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label className="form-label">
                                            Fee (falt fee or %)
                                          </label>
                                          <input
                                            {...register(`type_one_fee`, {
                                              required: "required",
                                            })}
                                            key="type_one_fee"
                                            type="text"
                                            placeholder={`eg. 25% or 2000000 (Flat Fee)`}
                                            className={`form-control ${
                                              errors.type_one_fee &&
                                              "is-invalid"
                                            }`}
                                          />
                                          <input
                                            {...register(`type_two_fee`, {
                                              required: "required",
                                            })}
                                            key="type_two_fee"
                                            type="text"
                                            placeholder={`eg. 25% or 2000000 (Flat Fee)`}
                                            className={`form-control ${
                                              errors.type_two_fee &&
                                              "is-invalid"
                                            } mt-1`}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-12 row">
                                      <div className="col-md-6">
                                        <div
                                          className="mb-3 border border-dark text-center"
                                          style={{
                                            borderColor:
                                              "rgba(221, 231, 241, 0.4)",
                                          }}
                                        >
                                          <label className="form-label p-0 mt-2 mb-1">
                                            Remaining Roles
                                          </label>
                                        </div>
                                      </div>

                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <input
                                            {...register(`type_three_fee`, {
                                              required: "required",
                                            })}
                                            key="type_three_fee"
                                            type="text"
                                            placeholder="eg. 25% or 2000000 (Flat Fee)"
                                            className={`form-control ${
                                              errors.type_three_fee &&
                                              "is-invalid"
                                            }`}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        ) : (
                          <div className="border rounded p-3 mb-3 col-md-9 row">
                            <div className="add-fields-info">
                              <div className="row">
                                <div className="col-md-3">
                                  <label className="form-label">
                                    Level Name *
                                  </label>
                                  <input
                                    {...register(`p_level_name.0`)}
                                    key="p_level_name.0"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_name?.[0] && "is-invalid"
                                    }`}
                                  />
                                  <input
                                    {...register(`p_level_name.1`)}
                                    key="p_level_name.1"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_name?.[1] && "is-invalid"
                                    } mt-1`}
                                  />
                                  <input
                                    {...register(`p_level_name.2`)}
                                    key="p_level_name.2"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_name?.[2] && "is-invalid"
                                    } mt-1`}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">
                                    Range From
                                  </label>
                                  <input
                                    {...register(`p_level_rangefrom.0`)}
                                    key="p_level_rangefrom.0"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_rangefrom?.[0] &&
                                      "is-invalid"
                                    }`}
                                  />
                                  <input
                                    {...register(`p_level_rangefrom.1`)}
                                    key="p_level_rangefrom.1"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_rangefrom?.[1] &&
                                      "is-invalid"
                                    } mt-1`}
                                  />
                                  <input
                                    {...register(`p_level_rangefrom.2`)}
                                    key="p_level_rangefrom.2"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_rangefrom?.[2] &&
                                      "is-invalid"
                                    } mt-1`}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Range To</label>
                                  <input
                                    {...register(`p_level_rangeto.0`)}
                                    key="p_level_rangeto.0"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_rangeto?.[0] &&
                                      "is-invalid"
                                    }`}
                                  />
                                  <input
                                    {...register(`p_level_rangeto.1`)}
                                    key="p_level_rangeto.1"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_rangeto?.[1] &&
                                      "is-invalid"
                                    } mt-1`}
                                  />
                                  <input
                                    {...register(`p_level_rangeto.2`)}
                                    key="p_level_rangeto.2"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_rangeto?.[2] &&
                                      "is-invalid"
                                    } mt-1`}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">
                                    Fixed Fee *
                                  </label>
                                  <input
                                    {...register(`p_level_amount.0`)}
                                    key="p_level_amount.0"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_amount?.[0] && "is-invalid"
                                    }`}
                                  />
                                  <input
                                    {...register(`p_level_amount.1`)}
                                    key="p_level_amount.1"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_amount?.[1] && "is-invalid"
                                    } mt-1`}
                                  />
                                  <input
                                    {...register(`p_level_amount.2`)}
                                    key="p_level_amount.2"
                                    type="text"
                                    className={`form-control ${
                                      errors.p_level_amount?.[2] && "is-invalid"
                                    } mt-1`}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                {extraInputs.map((index) => (
                                  <div
                                    key={index}
                                    className="d-flex row extra-title-row mt-1"
                                  >
                                    <div className="col-md-3">
                                      <input
                                        type="text"
                                        className={`form-control ${
                                          errors.p_level_name?.[index]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        {...register(`p_level_name.${index}`, {
                                          required: true,
                                        })}
                                        autoComplete="off"
                                        style={{ width: "130px" }}
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <input
                                        type="text"
                                        className={`form-control mb-1 ms-1 ${
                                          errors.p_level_rangefrom?.[index]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        {...register(
                                          `p_level_rangefrom.${index}`,
                                          { required: true }
                                        )}
                                        autoComplete="off"
                                        style={{ width: "130px" }}
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <input
                                        type="text"
                                        className={`form-control mb-1  ms-2 ${
                                          errors.p_level_rangeto?.[index]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        {...register(
                                          `p_level_rangeto.${index}`,
                                          { required: true }
                                        )}
                                        autoComplete="off"
                                        style={{ width: "130px" }}
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <div className="d-flex align-items-center">
                                        <input
                                          type="text"
                                          className={`form-control mb-1 ms-3 ${
                                            errors.p_level_amount?.[index]
                                              ? "is-invalid"
                                              : ""
                                          }`}
                                          {...register(
                                            `p_level_amount.${index}`,
                                            { required: true }
                                          )}
                                          autoComplete="off"
                                          style={{ width: "130px" }}
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm  ms-2"
                                          onClick={() => {
                                            unregister(`p_level_name.${index}`);
                                            unregister(
                                              `p_level_rangefrom.${index}`
                                            );
                                            unregister(
                                              `p_level_rangeto.${index}`
                                            );
                                            unregister(
                                              `p_level_amount.${index}`
                                            );
                                            setExtraInputs((prev) =>
                                              prev.filter((i) => i !== index)
                                            );
                                          }}
                                        >
                                          <i className="far fa-trash-alt"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                            <a
                              href="javascript:void(0);"
                              onClick={(e) => handleAddMore(e)}
                              className="text-primary fw-medium d-flex align-items-center"
                            >
                              <i className="ti ti-plus me-2"></i>Add New
                            </a>
                          </div>
                        )}
                      </div>
                      <div className="row col-md-12 border-bottom mb-3">
                        <div className="col-md-4 p-3">
                          <label className="form-label">
                            Expense (% or flat fee){!disableExpense && " *"}
                          </label>
                          <input
                            {...register("expensePercent", {
                              required: !disableExpense && "required",
                            })}
                            key="expensePercent"
                            type="text"
                            placeholder="eg. 10% or 200000"
                            className={`form-control ${
                              errors.expensePercent ? "is-invalid" : ""
                            }`}
                            disabled={disableExpense}
                            value={
                              disableExpense ? "On actual expense" : undefined
                            }
                            onChange={(e) => {
                              if (!disableExpense) {
                                setValue("expensePercent", e.target.value);
                              }
                            }}
                          />
                          {errors.expensePercent && (
                            <div className="invalid-feedback">
                              {errors.expensePercent.message}
                            </div>
                          )}
                        </div>

                        <div className="col-md-4 p-3 d-flex align-items-center">
                          <input
                            type="checkbox"
                            id="disableExpense"
                            checked={disableExpense}
                            onChange={() => {
                              setDisableExpense((prev) => {
                                const newValue = !prev;
                                if (newValue) {
                                  // Set field to "On actual expense" when disabled
                                  setValue(
                                    "expensePercent",
                                    "On actual expense"
                                  );
                                  clearErrors("expensePercent");
                                } else {
                                  // Clear field when re-enabled
                                  setValue("expensePercent", "");
                                }
                                return newValue;
                              });
                            }}
                          />
                          <label htmlFor="disableExpense" className="ms-2">
                            On actual expense
                          </label>
                        </div>

                        <div className="col-md-3 p-3">
                          <label className="form-label">Currency Type *</label>
                          <select
                            {...register("currency_id")}
                            className="form-select"
                          >
                            {currency.map((m) => (
                              <option key={m.id} value={m.id}>
                                {m.symbol} - {m.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="row col-md-12">
                        <div className="col-md-3 p-3">
                          <label className="form-label">Fee Cap Type</label>
                          <select
                            {...register("fee_cap_type")}
                            onChange={feeCapSelectChange}
                            className="form-select"
                          >
                            <option value="NA">NA</option>
                            <option value="Flat">Flat</option>
                            <option value="LevelWise">LevelWise</option>
                          </select>
                        </div>
                        {feecaptype === "Flat" ? (
                          <div className="p-3 mb-3 col-md-9 row">
                            <div className="mb-3 col-md-4">
                              <label className="form-label">
                                Fee Cap Amount
                              </label>
                              <input
                                {...register(`fee_cap_amount`)}
                                key="fee_cap_amount"
                                type="text"
                                className="form-control"
                              />
                            </div>
                            <div className="mb-3 col-md-4">
                              <label className="form-label">
                                Base Fee Cap Amount
                              </label>
                              <input
                                {...register(`base_fee_cap_amount`)}
                                key="base_fee_cap_amount"
                                type="text"
                                className="form-control"
                              />
                            </div>
                          </div>
                        ) : feecaptype === "LevelWise" ? (
                          <div className="p-3 mb-3 col-md-9 row">
                            <div className="add-fields-cap col-md-8">
                              <div className="row">
                                <div className="mb-1 col-md-6">
                                  <label className="form-label">
                                    Level Name
                                  </label>
                                  <input
                                    {...register(`p_levelcap_name.0`)}
                                    key="p_levelcap_name.0"
                                    type="text"
                                    className="form-control"
                                  />
                                  <input
                                    {...register(`p_levelcap_name.1`)}
                                    key="p_levelcap_name.1"
                                    type="text"
                                    className="form-control mt-1"
                                  />
                                  <input
                                    {...register(`p_levelcap_name.2`)}
                                    key="p_levelcap_name.2"
                                    type="text"
                                    className="form-control mt-1"
                                  />
                                </div>
                                <div className="mb-1 col-md-6">
                                  <label className="form-label">
                                    Level Cap Amount
                                  </label>
                                  <input
                                    {...register(`p_levelcap_amount.0`)}
                                    key="p_levelcap_amount.0"
                                    type="text"
                                    className="form-control"
                                  />
                                  <input
                                    {...register(`p_levelcap_amount.1`)}
                                    key="p_levelcap_amount.1"
                                    type="text"
                                    className="form-control mt-1"
                                  />
                                  <input
                                    {...register(`p_levelcap_amount.2`)}
                                    key="p_levelcap_amount.2"
                                    type="text"
                                    className="form-control mt-1"
                                  />
                                </div>
                              </div>
                              <div className="row">
                                {extraInputs.map((index) => (
                                  <div
                                    key={index}
                                    className="d-flex row extra-title-row mt-1"
                                  >
                                    <div className="col-md-6">
                                      <input
                                        type="text"
                                        className={`form-control ${
                                          errors.p_levelcap_name?.[index]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        {...register(
                                          `p_levelcap_name.${index}`,
                                          { required: true }
                                        )}
                                        autoComplete="off"
                                        style={{ width: "180px" }}
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <div className="d-flex align-items-center">
                                        <input
                                          type="text"
                                          className={`form-control mb-1 ms-3 ${
                                            errors.p_levelcap_amount?.[index]
                                              ? "is-invalid"
                                              : ""
                                          }`}
                                          {...register(
                                            `p_levelcap_amount.${index}`,
                                            { required: true }
                                          )}
                                          autoComplete="off"
                                          style={{ width: "177px" }}
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm  ms-2"
                                          onClick={() => {
                                            unregister(
                                              `p_levelcap_name.${index}`
                                            );
                                            unregister(
                                              `p_levelcap_amount.${index}`
                                            );
                                            setExtraInputs((prev) =>
                                              prev.filter((i) => i !== index)
                                            );
                                          }}
                                        >
                                          <i className="far fa-trash-alt"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                            <a
                              href="javascript:void(0);"
                              onClick={(e) => handleAddMore(e)}
                              className="text-primary fw-medium d-flex align-items-center"
                            >
                              <i className="ti ti-plus me-2"></i>Add New
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {Number(clientRetainerTypeId) === 1 && (            
              <div className="row">
                <div className="border-bottom mb-3">
                  <h4 className="mb-2">Billable Compensation Components</h4>

                  <div className="border rounded p-3 mb-3">
                    <input type="hidden" {...register("compensation_component_ids")} />
                    {["compensation", "other_cash", "equity"].map((category) => {
                      const categoryComponents = compensationComponents
                      .filter((component) => component.category === category)
                      .filter(
                        (component, index, self) =>
                          index === self.findIndex((c) => c.id === component.id)
                      );

                      if (categoryComponents.length === 0) {
                        return null;
                      }
                      const categoryTitle = category === "compensation" ? "Compensation" : category === "other_cash" ? "Other Cash Components in Year 1" : "Equity Compensation";
                      return (
                        <div key={category} className="mb-4">
                          <h5 className="mb-3">{categoryTitle}</h5>

                          <div className="row">
                            {categoryComponents.map((component) => {
                              const componentId = Number(component.id);

                              return (
                                <div className="col-md-6 col-lg-4 mb-3" key={componentId}>
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      id={`compensation_${componentId}`}
                                      value={componentId}
                                      checked={selectedCompensationComponents.includes(componentId)}
                                      onChange={(e) => handleCompensationComponentChange(componentId, e.target.checked)}
                                    />

                                    <label className="form-check-label ms-2" htmlFor={`compensation_${componentId}`}>
                                      {component.component_name}
                                    </label>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
              <div className="row">
                <div className="col-sm-12 row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label">
                      Resignation Replacement{" "}
                    </label>
                    <select
                      {...register("candidateRegPeriod")}
                      className="form-select"
                    >
                      <option value="1 months">1 months</option>
                      <option value="3 months">3 months</option>
                      <option value="6 months" selected>
                        6 months
                      </option>
                      <option value="9 months">9 months</option>
                      <option value="12 months">12 months</option>
                      <option value="16 months">16 months</option>
                      <option value="18 months">18 months</option>
                    </select>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">
                      Candidate Profile Validity
                    </label>
                    <select
                      {...register("candidateProfileValidity")}
                      className="form-select"
                    >
                      <option value="1 months">1 months</option>
                      <option value="3 months">3 months</option>
                      <option value="6 months">6 months</option>
                      <option value="9 months">9 months</option>
                      <option value="12 months">12 months</option>
                      <option value="16 months">16 months</option>
                      <option value="18 months">18 months</option>
                      <option value="24 months">24 months</option>
                    </select>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Invoice due in</label>
                    <select
                      {...register("invoice_due_in")}
                      className="form-select"
                    >
                      <option value="7">7</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="30">30</option>
                      <option value="45">45</option>
                      <option value="60">60</option>
                    </select>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Profile Validity Fee</label>
                    <input
                      {...register(`profileValidityFee`)}
                      key="profileValidityFee"
                      type="text"
                      className={`form-control ${
                        errors.profileValidityFee && "is-invalid"
                      }`}
                    />
                  </div>
                </div>
                <div className="col-sm-12 row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Termination Clause *</label>
                    <select
                      {...register("terminationClause")}
                      onChange={terminationClauseChange}
                      className="form-select"
                    >
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>
                  {terminationClause === "yes" ? (
                    <>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">Notice Period *</label>
                        <input
                          {...register(`noticePeriod`, {
                            required: "required",
                          })}
                          key="noticePeriod"
                          type="text"
                          className={`form-control ${
                            errors.noticePeriod && "is-invalid"
                          }`}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Termination Note *</label>
                        <input
                          {...register(`terminationNote`, {
                            required: "required",
                          })}
                          key="terminationNote"
                          type="text"
                          className={`form-control ${
                            errors.terminationNote && "is-invalid"
                          }`}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-12 row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label">No Poach Clause *</label>
                    <select
                      {...register("noPoachClause")}
                      onChange={(e) => nopoachChange(e.target.value)}
                      className="form-select"
                    >
                      <option value="no">No</option>
                      <option value="country">Country</option>
                      <option value="region">Region</option>
                    </select>
                  </div>
                  {nopoach == "country" ? (
                    <>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">No Poach Country *</label>
                        <select
                          {...register("country_id", { required: "Required" })}
                          multiple
                          className={`form-select select2`}
                        >
                          {countries.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">
                          No Poach End Date *
                        </label>
                        <div className="input-icon position-relative w-100 me-2">
                          <input
                            {...register(`noPoachEndDateCountry`, {
                              required: "required",
                            })}
                            type="date"
                            className={`datetimepicker form-control ${
                              errors.noPoachEndDateCountry && "is-invalid"
                            }`}
                            placeholder="dd/mm/yyyy"
                          />
                        </div>
                      </div>
                    </>
                  ) : nopoach == "region" ? (
                    <>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">No Poach Region *</label>
                        <select
                          {...register("region_id")}
                          multiple
                          className="form-select select2"
                        >
                          {regions.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">
                          No Poach End Date *
                        </label>
                        <div className="input-icon position-relative w-100 me-2">
                          <input
                            {...register(`noPoachEndDateRegion`, {
                              required: "required",
                            })}
                            type="date"
                            className={`datetimepicker form-control ${
                              errors.noPoachEndDateRegion && "is-invalid"
                            }`}
                            placeholder="dd/mm/yyyy"
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-12 row">
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Comments</label>
                    <input
                      {...register(`comments`)}
                      key="comments"
                      type="text"
                      className={`form-control ${
                        errors.comments && "is-invalid"
                      }`}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Contract File</label>
                    <input
                      type="file"
                      className="form-control"
                      {...register("file_name", {
                            validate: (files) => {
                              if (!files || files.length === 0) return true;
                              const file = files[0];
			                        return (
                                file.type === "application/pdf" &&
                                file.name.toLowerCase().endsWith(".pdf")
                              ) || "Only PDF files are allowed";
                            },
                          })}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">DPA File</label>
                    <input
                      type="file"
                      className="form-control"
                      {...register("file_name1")}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                onClick={onClose}
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Update Contract
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditContract;
